/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Mode_ExtractInputs */

const en_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extract Captions`)
};

const fr_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraire les sous-titres`)
};

const de_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszug aus den Bildunterschriften`)
};

const it_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrai didascalie`)
};

const ru_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечь подписи`)
};

const es_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraer subtítulos`)
};

const zh_cn2_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提取字幕`)
};

const ja_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションの抽出`)
};

const hi_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन निकालें`)
};

const pt_pt2_drastic_tech_mode_extract = /** @type {(inputs: Drastic_Tech_Mode_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas de trechos`)
};

/**
* | output |
* | --- |
* | "Extract Captions" |
*
* @param {Drastic_Tech_Mode_ExtractInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_mode_extract = /** @type {((inputs?: Drastic_Tech_Mode_ExtractInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Mode_ExtractInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_mode_extract(inputs)
	if (locale === "de") return de_drastic_tech_mode_extract(inputs)
	if (locale === "it") return it_drastic_tech_mode_extract(inputs)
	if (locale === "ru") return ru_drastic_tech_mode_extract(inputs)
	if (locale === "es") return es_drastic_tech_mode_extract(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_mode_extract(inputs)
	if (locale === "ja") return ja_drastic_tech_mode_extract(inputs)
	if (locale === "hi") return hi_drastic_tech_mode_extract(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_mode_extract(inputs)
	return en_drastic_tech_mode_extract(inputs)
});